/* global Config */

const configBase = {
    baseUrl: Config.base.vortexManagementPath,
    contentType: 'application/json',
    crossDomain: false,
    method: 'GET',
    responseType: 'json',
    timeout: 60000,
};

export const serviceConfig = {
    CLIENT: {
        ...configBase,
        path: 'clients',
        route: 'client',
    },
    CREATE_CLIENT: {
        ...configBase,
        path: 'clients',
        method: 'POST',
    },
    UPDATE_CLIENT: {
        ...configBase,
        path: 'clients',
        method: 'PUT',
    },
    ROLE: {
        ...configBase,
        path: 'roles',
        route: 'role',
    },
    CREATE_ROLE: {
        ...configBase,
        path: 'roles',
        method: 'POST',
        childServiceKeys: ['CLIENT'],
    },
    UPDATE_ROLE: {
        ...configBase,
        path: 'roles',
        method: 'PUT',
        childServiceKeys: ['CLIENT'],
    },
    USER: {
        ...configBase,
        path: 'users',
        route: 'users',
    },
    CREATE_USER: {
        ...configBase,
        path: 'users',
        method: 'POST',
        childServiceKeys: ['ROLE'],
    },
    UPDATE_USER: {
        ...configBase,
        path: 'users',
        method: 'PUT',
        childServiceKeys: ['ROLE'],
    },
    UPDATE_FORGOT_PASSWORD: {
        ...configBase,
        path: 'forgotPassword',
        method: 'POST',
        payloadType: 'params',
    },
    UPDATE_RESET_PASSWORD: {
        ...configBase,
        path: 'resetPassword',
        method: 'POST',
        payloadType: 'params',
    },
};
